import BaseView from 'source/lib/base_view';
import template from 'authentication/templates/404.html';

const NotFoundView = BaseView.extend({
    template
});

export default NotFoundView;



// WEBPACK FOOTER //
// ./authentication/static-source/js/authentication/404.js